"use client";

import { useEffect, useState } from "react";

import { useDeskMonitor } from "../DeskMonitor";

const RUNS_FORMAT = new Intl.NumberFormat("en-US");

/**
 * Today's runs in the agents' title bar, one more as each run lands in the
 * feed. The feed's rows play from CSS delays; `arrivals` holds the same
 * moments, computed once on the server, so the count and the rows agree.
 */
export default function RunsCount({
  runsToday,
  arrivals,
}: {
  runsToday: number;
  arrivals: readonly number[];
}) {
  const { isStarted } = useDeskMonitor();
  const [arrived, setArrived] = useState(0);

  useEffect(() => {
    if (!isStarted) {
      return;
    }

    const timers = arrivals.map((at, index) => window.setTimeout(() => setArrived(index + 1), at));

    return () => timers.forEach((timer) => window.clearTimeout(timer));
  }, [isStarted, arrivals]);

  return <>{RUNS_FORMAT.format(runsToday + arrived)}</>;
}
